import { render, staticRenderFns } from "./UiTabs2.vue?vue&type=template&id=2a8826e2&scoped=true&"
import script from "./UiTabs2.vue?vue&type=script&lang=ts&"
export * from "./UiTabs2.vue?vue&type=script&lang=ts&"
import style0 from "./UiTabs2.vue?vue&type=style&index=0&id=2a8826e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8826e2",
  null
  
)

export default component.exports